import React from "react";
import RectangleCard from "components/v2/Cards/RectangleCard/RectangleCard";
import { FactorProps } from "components/v2/Factor/types/FactorProps";
import classes from "./Factor.module.scss";
import { timeStampToPersianDate } from "utils/v2/timeAndDate";
import Button from "components/v2/Button/Button";
import { useNavigate } from "react-router-dom";
import { getTheme } from "utils/v2/theme";
import useTypedTranslation from "hooks/V2/common/useTypedTranslation";

const Factor: React.FC<FactorProps> = ({ renewal }) => {
  //hooks
  const navigate = useNavigate();
  const { translate } = useTypedTranslation();

  //navigation
  const navigateToFactorDetail = (factorID: number) => {
    navigate(`/transactions/factor/${factorID}`);
  };

  return (
    <RectangleCard
      darker
      key={renewal.id}
      additionalClassNames={classes.container}
    >
      <div className={classes.id}>
        <p>شماره فاکتور</p>
        <span>{renewal?.id}</span>
      </div>
      {renewal?.paid_at && (
        <div className={classes.date}>
          <p>تاریخ پرداخت</p>
          <span>{timeStampToPersianDate(renewal.paid_at)}</span>
        </div>
      )}

      <div className={classes.price}>
        <p>مبلغ کل</p>
        <span>{`${
          (renewal?.total_amount + renewal?.total_warranty_amount) / 10 +
          translate("Toman")
        }`}</span>
      </div>
      <div className={classes.status}>
        <p>وضعیت پرداخت</p>
        <span className={renewal.is_paid ? classes.success : classes.failed}>
          {renewal?.is_paid ? "موفق" : "ناموفق"}
        </span>
      </div>
      <Button
        type={getTheme() === "dark" ? "others" : "basic"}
        color={getTheme() === "dark" ? "gray" : ""}
        text={renewal?.is_paid ? "مشاهده فاکتور" : "مشاهده فاکتور و پرداخت"}
        additionalStyles={classes.show}
        onClick={() => navigateToFactorDetail(renewal?.id)}
      />
    </RectangleCard>
  );
};
export default Factor;
